// extracted by mini-css-extract-plugin
module.exports =  {"container":"c85e813ac9--container--BUk9E","btn":"c85e813ac9--btn--Ag1G5","tablet":"c85e813ac9--tablet--R8o0D","phone":"c85e813ac9--phone--POjA9"};